const supportedLocales = ['es'];

module.exports = { supportedLocales };
